export default "__VITE_ASSET__kpG5hiHf__"